import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import QrReader from 'react-qr-reader'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { green, red } from '@material-ui/core/colors';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Avatar from '@material-ui/core/Avatar';
import Skeleton from '@material-ui/lab/Skeleton';

import CloseIcon from '@material-ui/icons/Close';
import DraftsIcon from '@material-ui/icons/Drafts';
import PersonIcon from '@material-ui/icons/Person';

import Loading from 'app/components/loaders/Loading';
import RedButton from 'app/components/buttons/RedButton';
import GreenButton from 'app/components/buttons/GreenButton';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    dialogContent: {
        backgroundColor: theme.palette.grey[200]
    },
    invitationContainer: {
        height: '100vh'
    },
    noinvitation: {
        height: '100vh'
    },
    marginBottom: {
        marginBottom: theme.spacing(3)
    },
    marginBottomSmall: {
        marginBottom: theme.spacing(1)
    },
    marginTop: {
        marginTop: theme.spacing(2)
    },
    height: {
        height: '100%'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    buttonText: {
        fontSize: 20,
    },
    paperMembership: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(3)
    },
    green: {
        color: '#fff',
        backgroundColor: green[600],
    },
    red: {
        color: '#fff',
        backgroundColor: red[600],
    },
    statusError: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        textAlign: 'center',
        backgroundColor: red[600]
    },
    statusSuccess: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        textAlign: 'center',
        backgroundColor: green[600]
    },
    statusMessage: {
        color: '#ffffff'
    }
    
}));


export default function QrScannerDialog(props) {

    const { open, onClose, event } = props;

    const classes = useStyles();
    const api = useApi();
    const theme = useTheme();
    const mdDown = useMediaQuery(theme.breakpoints.down('sm'));

    const [ code, setCode ] = useState(null);
    const [ scannerReady, setScannerReady ] = useState(false);

    const [ invitation, setInvitation ] = useState(null);
    const [ invitationLoading, setInvitationLoading ] = useState(false);

    const [ errors, setErrors ] = useState({});

    // Getters ------------------------------------------------

    const getInvitation = data => {
        if (data && !code) {

            setCode(data);
            setInvitationLoading(true);

            api.get(`/admin/event/${event.id}/scan/${data}`)
                .then(res => setInvitation(res.invitation))
                .catch(error => {
                    if (error?.response?.data?.errors) {
                        setErrors(error.response.data.errors)
                    }
                }).finally(() => setInvitationLoading(false))
        }
    }

    // Handlers --------------------------------------------------

    const handleResetScanner = () => {
        setCode(null);
        setInvitation(null);
        setInvitationLoading(false);
        setErrors({})
    }

    const handleError = error => {
        setErrors({...errors, scanner: error })
    }

    const handleClose = () => {
        handleResetScanner();
        onClose();
    }

    // Posters --------------------------------------------------

    const postEnter = () => {
        setInvitationLoading(true);
        api.post(`/admin/invitation/${invitation.id}/enter`).finally(() => handleResetScanner());
    }

    const postFlagInvitation = () => {
        setInvitationLoading(true);
        api.post(`/admin/invitation/${invitation.id}/flag`).finally(() => handleResetScanner());
    }

    const postDateEnter = () => {
        // Need to add this function on later iterations
    }

    // Constants ----------------------------------------

    const invitedby = () => {
        if (invitation?.invitable_type === 'App\\Models\\User') return (<span>Invited By: <strong>{invitation?.invitable.full_name}</strong></span>);
        else if (invitation) return (<span>Invited By: <strong>{invitation?.invitable.title}</strong></span>);
        return (<strong>Unknown Inviter</strong>);
    }

    const outstandingInvoices = () => {
        if (! invitation) return false;

        const oi = [];

        invitation.guest.invoices.forEach(inv => {
            if (! inv.paid) oi.push(inv);
        })

        return oi;
    }

    const hasErrors = () => {

        if (! invitation) return false;

        // Need to check for Dates in future build!!!!!!
        if (invitation.entered_at !== null) return true;

        const oi = outstandingInvoices();

        if (oi.length > 0) return true;

        return false;
    }

    const getStatusMessage = () => {
        if (hasErrors()) {

            if (invitation?.entered_at !== null) return "Guest has already entered the event.";

            const oi = outstandingInvoices();

            if (oi.length > 0) return `Guest has ${oi.length} unpaid invoice(s).`;

            return "Unknown Error";
        }

        return "Guest can enter the event."
    }

    const getActionButton = () => {
        if (hasErrors()) return (
            <RedButton 
                onClick={postFlagInvitation} 
                disabled={invitationLoading || !invitation}
                variant="contained"
                className={classes.buttonText}
                >
                Flag Invitation
            </RedButton>
        )

        return (
            <GreenButton 
                onClick={postEnter} 
                disabled={invitationLoading || !invitation}
                variant="contained"
                className={classes.buttonText}
                >
                Enter Event
            </GreenButton>
        )
    }

    return (
        <Dialog
            open={open}
            fullScreen={mdDown}
            fullWidth
            maxWidth="sm"
            onClose={handleClose}
            aria-labelledby="qr-code-scanner-dialog-title"
            className={classes.height}
            >
            <Loading isLoading={invitationLoading}/>
            <DialogTitle id="qr-code-scanner-dialog-title">
                <span>QR Code Scanner</span>
                <IconButton aria-label="Cancel" className={classes.closeButton} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers className={classes.dialogContent}>
                <Collapse in={code}>
                    <div className={classes.invitationContainer}>
                        {(! invitationLoading && ! invitation) ? (
                            <Grid container className={classes.noInvitation} alignItems="center" justifyContent='center' spacing={(3)}>
                                <Grid item>
                                    <Alert severity="error">
                                        <AlertTitle>Error</AlertTitle>
                                        No Invitation was found for this QR Code. Please try again.
                                    </Alert>
                                </Grid>
                            </Grid>
                        ) : (
                            <Card className={classes.invitation}>
                                <CardHeader
                                    avatar={
                                        invitationLoading ? (
                                            <Skeleton animation="wave" variant="circle" width={40} height={40} />
                                        ) : (
                                            <Avatar className={hasErrors() ? classes.red : classes.green}>
                                                <DraftsIcon />
                                            </Avatar>
                                        )
                                    }
                                    title={
                                        invitationLoading ? (
                                            <Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />
                                        ) : (
                                            <span>{invitation.guest.full_name}</span>
                                        )
                                    }
                                    subheader={
                                        invitationLoading ? (
                                            <Skeleton animation="wave" height={10} width="40%" />
                                        ) : (
                                            <span>{invitedby()}</span>
                                        )
                                    }
                                />
                                <div className={hasErrors() ? classes.statusError : classes.statusSuccess}>
                                    <Typography variant="h5" className={classes.statusMessage}>{getStatusMessage()}</Typography>
                                </div>
                                <CardContent>
                                    <Typography variant="subtitle1" className={classes.marginTop}>Details:</Typography>
                                    <Typography variant="body1">{invitation?.details}</Typography>
                                    <Typography variant="subtitle1" className={classes.marginTop}>Dates:</Typography>
                                    {(invitation?.dates.length > 0) ? invitation.dates.map(date => (
                                        <CardHeader
                                            avatar={
                                                <Avatar>
                                                    <PersonIcon />
                                                </Avatar>
                                            }
                                            title={date.name}
                                        />
                                    )) : (
                                        <Typography variant="body1">This invitation does not have any dates associated with it.</Typography>
                                    )}
                                </CardContent>
                            </Card>
                        )}
                    </div>
                </Collapse>
                <div className={classes.scannerContainer}>
                    <Loading isLoading={! scannerReady}/>
                    <QrReader
                        delay={500}
                        onError={handleError}
                        onScan={getInvitation}
                        onLoad={() => setScannerReady(true)}
                        className={classes.scanner}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Grid container alignItems="center" justifyContent='space-between' spacing={3}>
                    <Grid item>
                        <Button disabled={! code} onClick={handleResetScanner} className={classes.buttonText}>Reset Scanner</Button>
                    </Grid>
                    <Grid item>
                        {getActionButton()}
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}
